import { Form, Radio, Row, Col, Space } from "antd";
import { ContainerForm } from "../styles";
import { useEffect } from "react";
import { validarCampos } from "../utils/validadores";
import { Interesse } from "../Interface/Interesse";

interface FormMaisInteresseProps {
  setFormMaisInteresse: (values: any) => void;
  formMaisInteresse: any;
  onValidChange: (isValid: boolean) => void;
}

export default function FormMaisInteresse({
  setFormMaisInteresse,
  formMaisInteresse,
  onValidChange,
}: FormMaisInteresseProps) {
  const [form] = Form.useForm();

  const formChange = (_: Partial<any>, allValues: any) => {
    const values = form.getFieldsValue(["aluguel", "troca", "compra", "venda"]);

    const isValid = validarCampos<Interesse>(values, [
      "aluguel",
      "troca",
      "compra",
      "venda",
    ]);

    onValidChange(isValid);
    if (isValid) {
      setFormMaisInteresse(allValues);
    }
  };

  useEffect(() => {
    if (formMaisInteresse) {
      form.setFieldsValue(formMaisInteresse);
    }
  }, [formMaisInteresse, form]);

  return (
    <ContainerForm>
      <Form
        form={form}
        layout="vertical"
        style={{ width: "100%", maxWidth: 600 }}
        onValuesChange={(changedValues, allValues) =>
          formChange(changedValues, allValues)
        }
      >
        <Row
          gutter={[16, 16]}
          style={{
            maxHeight: "100%",
            overflowY: "auto",
            paddingRight: 8,
          }}
        >
          {[
            { name: "aluguel", label: "Alugar" },
            { name: "troca", label: "Trocar" },
            { name: "compra", label: "Compra" },
            { name: "venda", label: "Venda" },
          ].map(({ name, label }) => (
            <Col key={name} xs={24} sm={12} style={{ marginBottom: 16 }}>
              <Form.Item
                name={name}
                label={label}
                style={{ fontWeight: 600, fontSize: 14 }}
                rules={[
                  {
                    required: true,
                    message: `Selecione uma opção para ${label}.`,
                  },
                ]}
              >
                <Radio.Group
                  style={{
                    background: "#fafafa",
                    padding: 12,
                    borderRadius: 6,
                    width: "100%",
                    boxSizing: "border-box",
                  }}
                >
                  <Space size="middle" wrap>
                    <Radio
                      value={0}
                      style={{
                        fontSize: 14,
                        padding: "6px 16px",
                        cursor: "pointer",
                        minWidth: 100,
                      }}
                    >
                      Não
                    </Radio>
                    <Radio
                      value={1}
                      style={{
                        fontSize: 14,
                        padding: "6px 16px",
                        cursor: "pointer",
                        minWidth: 100,
                      }}
                    >
                      Sim
                    </Radio>
                  </Space>
                </Radio.Group>
              </Form.Item>
            </Col>
          ))}
        </Row>
      </Form>
    </ContainerForm>
  );
}
